import { featuresData } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100/70">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            平台特色
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            五大核心优势，打造极致的在线追剧体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {featuresData.map((feature) => (
            <div
              key={feature.id}
              className="flex flex-col items-center text-center p-5 md:p-6 bg-background-50 rounded-lg border border-background-200/60"
            >
              <span className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-primary-100 mb-4">
                <i className={`${feature.icon} text-xl md:text-2xl text-primary-500`}></i>
              </span>
              <h3 className="text-base font-bold font-heading text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}